import { render } from "./UserGroupEdit.vue?vue&type=template&id=7ba1f137&scoped=true"
import script from "./UserGroupEdit.vue?vue&type=script&lang=js"
export * from "./UserGroupEdit.vue?vue&type=script&lang=js"

import "./UserGroupEdit.vue?vue&type=style&index=0&id=7ba1f137&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba1f137"]])

export default __exports__